<!-- Modals -->
<app-common-bulk-select-employee-dialog #assignEmployeesModal [label]="'assign'">
    <ui-banner variant="warning" *ngIf="field?.assignedEmployeesCount" class="margin-bottom-2" style="width: 100%">
        <p>{{ 'settings.custom-fields.unassignEmployeeNotice' | translate }}</p>
    </ui-banner>
</app-common-bulk-select-employee-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'settings.custom-fields.addOrRemoveEmployees' | translate }}"
        [back]="true"
        [backRoute]="'/settings/custom-fields/fields/' + field.id"
    >
        <div *ngIf="field.assignedEmployeesCount" class="buttons">
            <ui-button (click)="onAssignEmployees()" type="link">{{
                'settings.custom-fields.addRemoveEmployees' | translate
            }}</ui-button>
        </div>
    </app-header>

    <ng-container *ngIf="field.assignedEmployeesCount; else noEmployeesAssigned">
        <ui-card class="assigned-employees-table">
            <app-table
                title="{{ 'settings.custom-fields.employees' | translate }}"
                subTitle="{{ 'settings.custom-fields.youMayFillOutIfYouHavePermission' | translate }}"
                [embedded]="true"
                [showOffset]="false"
                [useStickyHeader]="false"
                [table]="assignedEmployeesAndInteractableFieldValuesTable"
            >
            </app-table>
        </ui-card>
    </ng-container>

    <!-- Empty state i.e. no employees assigned -->
    <ng-template #noEmployeesAssigned>
        <ui-card style="height: 400px">
            <h2>{{ 'settings.custom-fields.employees' | translate }}</h2>
            <p>{{ 'settings.custom-fields.noEmployeesSelected' | translate }}</p>
            <ui-button (click)="onAssignEmployees()" type="outline"
                >{{ 'settings.custom-fields.selectEmployees' | translate }}
            </ui-button>
        </ui-card>
    </ng-template>
</div>

<div class="flex justify-end margin-right-7 margin-bottom-5">
    <ui-button (click)="onDone()" type="primary">{{ 'settings.done' | translate }} </ui-button>
</div>
